import { render, staticRenderFns } from "./ChartWidgetType.vue?vue&type=template&id=54268cc2&"
import script from "./ChartWidgetType.vue?vue&type=script&lang=js&"
export * from "./ChartWidgetType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../create-website/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports